/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AssessmentRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let person = this.modelFor('people.person').person;
    return hash({
      assessment: store.findRecord(
        'assessments/assessment',
        params.assessment_id,
      ),
      modules: store.query('assessments/module', {
        assessmentId: params.assessment_id,
      }),
      person,
      grades: store.query('assessments/grade', {
        assessmentId: params.assessment_id,
        personId: person.id,
      }),
    });
  }
}
